import LazyHydrate from 'react-lazy-hydration'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { PortraitRowCollection } from '@/molecules/PortraitRowCollection'
import { findTitleProjectSlug, formatTitleLikeVerticalImagePath, formatWatchPath } from '@/services/ContentCatalog'
import { useGuildMember } from '@/services/GuildUserService'
import { CatalogTitleForMap, LinkViewModel, LinksViewProps } from '@/services/RenderService'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { logger } from '@/utils/logging'
import { LargePortraitLink } from './LargePortraitLink'

export function LargePortraitRail(props: LinksViewProps) {
  const { isGuildMember, loading } = useGuildMember()
  const testId = `large-portrait-rail-${props.id}`

  return (
    <LazyHydrate whenVisible>
      <PaddedContainer className="!-mt-2 overflow-x-hidden !pt-2" fluid>
        <PortraitRowCollection id={props.id} testId={testId} slidesToScroll={6} slidesToShow={6} haltLazyLoad>
          {props.links.map((link) => (
            <LargePortraitLink
              key={link.name}
              link={link}
              className="mb-2 mr-4 max-h-full overflow-hidden"
              isGuildMember={isGuildMember}
              loading={loading}
            />
          ))}
        </PortraitRowCollection>
      </PaddedContainer>
    </LazyHydrate>
  )
}

LargePortraitRail.mapTitle = mapTitleToLink

export function mapTitleToLink(title: CatalogTitleForMap): LinkViewModel | undefined {
  const path = formatTitleLikeVerticalImagePath(title)
  const imageUrl = path && getCloudinaryImageUrl({ path, width: 294, height: 441 })
  const linkUrl = formatWatchPath(title)

  if (!imageUrl || !linkUrl) {
    logger().error(
      `A link view model cannot be created for this title because one or both of imageUrl and linkUrl could not be generated.`,
      { component: LargePortraitRail.name, title, imageUrl, linkUrl },
    )
    return
  }

  return {
    name: title.title,
    alt: title.title,
    imageUrl,
    linkUrl,
    track: {
      eventName: 'Project Tile Clicked',
      payload: {
        name: title.title,
        slug: findTitleProjectSlug(title),
        label: title.description.short,
        tileType: 'large_portrait_rail',
        imageUrl,
        linkUrl,
      },
    },
  }
}
